// Data de encerramento do acesso ao conteúdo (16 de Junho de 2025 às 08:00)
export const CONTENT_ACCESS_DEADLINE = '2025-06-16T08:00:00';

// Data de encerramento do preço promocional (17 de Junho de 2025 às 00:00)
export const PAYMENT_DEADLINE = '2025-06-17T00:00:00';

// Função auxiliar para verificar se já passou do prazo de pagamento
export const isAfterPaymentDeadline = () => {
  const deadline = new Date(PAYMENT_DEADLINE);
  const now = new Date();
  return now > deadline;
};

// Função auxiliar para garantir que a data seja criada corretamente
export const getContentDeadline = () => new Date(CONTENT_ACCESS_DEADLINE);

// Links externos
export const WHATSAPP_GROUP_LINK = 'https://chat.whatsapp.com/CDBjL9lprdVAts3GYE8S2b';

// Links de redes sociais
export const SOCIAL_LINKS = {
  LINKEDIN: 'https://www.linkedin.com/in/danieleleaoevangelista',
  INSTAGRAM: 'https://www.instagram.com/danieleleaoe',
  GITHUB: 'https://github.com/danileao',
  YOUTUBE: 'https://www.youtube.com/danieleleao',
  YOUTUBE_CHANNEL: 'https://youtube.com/@danieleleao',
  WHATSAPP_CONTACT: 'https://wa.me/+5511993613809'
} as const;

// Links de plataforma
export const PLATFORM_LINKS = {
  COURSES: 'https://cursos.danieleleao.com.br',
  HOTMART_PAYMENT: 'https://pay.hotmart.com/A99776426B?checkoutMode=10',
  HOTMART_PAYMENT_AFTER_DEADLINE: 'https://pay.hotmart.com/S100109211V?checkoutMode=10'
} as const;

// Imagens
export const IMAGES = {
  INSTRUCTOR: 'https://static-media.hotmart.com/bA9jLWmkRQu7lOmYuDWTlfh9riA=/filters:quality(100):format(webp)/klickart-prod/uploads/media/file/8242028/dani-whats.jpeg'
} as const;

// Links externos
export const EXTERNAL_LINKS = {
  GOOGLE_CALENDAR_BASE: 'https://calendar.google.com/calendar/render?action=TEMPLATE'
} as const; 